function Box({ children, tone }) {
  return <div className={`flow-box${tone ? ` flow-box--${tone}` : ""}`}>{children}</div>;
}

function Edge({ label, dir = "right" }) {
  return (
    <div className={`flow-edge flow-edge--${dir}`} aria-hidden="true">
      {label ? <span className="flow-edge__label">{label}</span> : null}
      <span className="flow-edge__shaft" />
    </div>
  );
}

function Subgraph({ title, note, children, tone }) {
  return (
    <div className={`flow-subgraph${tone ? ` flow-subgraph--${tone}` : ""}`}>
      <p className="flow-subgraph__title">{title}</p>
      {note ? <p className="flow-subgraph__note">{note}</p> : null}
      <div className="flow-stack">{children}</div>
    </div>
  );
}

export function ConnectionsFlowchart() {
  return (
    <figure className="flow-chart">
      <figcaption className="flow-chart__caption">How the two origins connect</figcaption>
      <div className="flow-lr" role="img" aria-label="REChecklist desks and admin connect to Journey support and hubs through the shared hub pack">
        <Subgraph title="REChecklist.pro" note="App · working desks" tone="app">
          <Box>Buyer · Seller · Agent · Broker desks</Box>
          <Box tone="desk">The Hub (agents &amp; brokers)</Box>
          <Box tone="desk">Footer Support</Box>
          <Box tone="desk">Agent / Broker Billing</Box>
          <Box tone="admin">Admin Controls</Box>
        </Subgraph>
        <div className="flow-edge-col">
          <Edge label="supportUrl + role" />
          <Edge label="payUrl + role" />
          <Edge label="writes @hub" />
        </div>
        <Subgraph title="DreamHomeJourney.online" note="Hub · sales and support" tone="hub">
          <Box tone="hub">/support?role=&amp;user=</Box>
          <Box tone="hub">/pay?role=&amp;user=</Box>
          <Box>Board · Events · Pro · Clients</Box>
          <Box>Open the app · Login</Box>
        </Subgraph>
        <div className="flow-edge-col">
          <Edge label="reads seed" />
          <Edge label="open app" dir="left" />
        </div>
        <Subgraph title="shared/hub" note="Same seed · separate stores">
          <Box>Articles</Box>
          <Box>Vendors · BBS · events</Box>
          <Box>Blurbs · visibility</Box>
        </Subgraph>
      </div>
    </figure>
  );
}

export function JourneyFlowchart() {
  return (
    <figure className="flow-chart">
      <figcaption className="flow-chart__caption">DreamHomeJourney.online routes</figcaption>
      <div className="flow-tb" role="img" aria-label="Home branches to guide, support, vendors, events, and community">
        <div className="flow-tb__row flow-tb__row--one">
          <Box tone="hub">/ Home</Box>
        </div>
        <Edge dir="down" />
        <div className="flow-tb__row flow-tb__row--four">
          <Box>/guide</Box>
          <Box tone="hub">/support</Box>
          <Box>/vendors</Box>
          <Box>/events</Box>
        </div>
        <Edge dir="down" label="from Support and hubs" />
        <div className="flow-tb__row flow-tb__row--four">
          <Box>/support/:role</Box>
          <Box>/support/tour</Box>
          <Box>/vendors/:id</Box>
          <Box>/events/:id</Box>
        </div>
        <Edge dir="down" />
        <div className="flow-tb__row flow-tb__row--four">
          <Box>/community</Box>
          <Box>/calendar</Box>
          <Box>/login · /pay</Box>
          <Box>/why · /benefits</Box>
        </div>
      </div>
    </figure>
  );
}

export function ChecklistFlowchart() {
  return (
    <figure className="flow-chart">
      <figcaption className="flow-chart__caption">REChecklist.pro desks and journeys</figcaption>
      <div className="flow-tb" role="img" aria-label="Public home branches to buyer and seller journeys and to agent, broker, and admin desks">
        <div className="flow-tb__row flow-tb__row--one">
          <Box>Home /</Box>
        </div>
        <Edge dir="down" />
        <div className="flow-tb__row flow-tb__row--four">
          <Box>/dashboard</Box>
          <Box>/register · logins</Box>
          <Box>/notices</Box>
          <Box>/install</Box>
        </div>
        <Edge dir="down" />
        <div className="flow-tb__row flow-tb__row--two">
          <Box tone="buyer">Buyer /start … /complete</Box>
          <Box tone="seller">Seller /seller/home …</Box>
        </div>
        <Edge dir="down" label="client threads" />
        <div className="flow-tb__row flow-tb__row--one">
          <Box>/client/messages</Box>
        </div>
        <Edge dir="down" />
        <div className="flow-tb__row flow-tb__row--three">
          <Box tone="desk">Agent /agent/*</Box>
          <Box tone="desk">Broker /broker/*</Box>
          <Box tone="admin">Admin /admin/*</Box>
        </div>
      </div>
    </figure>
  );
}

export function PathFlowchart({ title, steps, tone }) {
  return (
    <figure className="flow-chart flow-chart--path">
      <figcaption className="flow-chart__caption">{title}</figcaption>
      <ol className="flow-path" aria-label={title}>
        {steps.map((step, index) => (
          <li key={step} className="flow-path__item">
            <Box tone={tone}>{step}</Box>
            {index < steps.length - 1 ? <Edge dir="right" /> : null}
          </li>
        ))}
      </ol>
    </figure>
  );
}
